import clsx, { type ClassValue } from 'clsx';

/**
 * Единственная обёртка над clsx. Tailwind в проекте нет, поэтому merge-логика
 * классов не нужна — CSS Modules гарантируют уникальность имён.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}

export type { ClassValue };
